import _taggedTemplateLiteral from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { RouterController } from '@web3modal/core';
import { customElement } from '@web3modal/ui';
import { LitElement, html } from 'lit';
import { state } from 'lit/decorators.js';
import styles from './styles.js';
let W3mRouter = class W3mRouter extends LitElement {
  constructor() {
    super();
    this.resizeObserver = undefined;
    this.prevHeight = '0px';
    this.prevHistoryLength = 1;
    this.unsubscribe = [];
    this.view = RouterController.state.view;
    this.unsubscribe.push(RouterController.subscribeKey('view', val => this.onViewChange(val)));
  }
  firstUpdated() {
    this.resizeObserver = new ResizeObserver(async _ref => {
      let [content] = _ref;
      const height = "".concat(content === null || content === void 0 ? void 0 : content.contentRect.height, "px");
      if (this.prevHeight !== '0px') {
        await this.animate([{
          height: this.prevHeight
        }, {
          height
        }], {
          duration: 150,
          easing: 'ease',
          fill: 'forwards'
        }).finished;
        this.style.height = 'auto';
      }
      this.prevHeight = height;
    });
    this.resizeObserver.observe(this.getWrapper());
  }
  disconnectedCallback() {
    var _this$resizeObserver;
    (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.unobserve(this.getWrapper());
    this.unsubscribe.forEach(unsubscribe => unsubscribe());
  }
  render() {
    return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["<div>", "</div>"])), this.viewTemplate());
  }
  viewTemplate() {
    switch (this.view) {
      case 'Connect':
        return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<w3m-connect-view></w3m-connect-view>"])));
      case 'ConnectingWalletConnect':
        return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<w3m-connecting-wc-view></w3m-connecting-wc-view>"])));
      case 'ConnectingExternal':
        return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<w3m-connecting-external-view></w3m-connecting-external-view>"])));
      case 'ConnectingSiwe':
        return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<w3m-connecting-siwe-view></w3m-connecting-siwe-view>"])));
      case 'AllWallets':
        return html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<w3m-all-wallets-view></w3m-all-wallets-view>"])));
      case 'Networks':
        return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<w3m-networks-view></w3m-networks-view>"])));
      case 'SwitchNetwork':
        return html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<w3m-network-switch-view></w3m-network-switch-view>"])));
      case 'Account':
        return html(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["<w3m-account-view></w3m-account-view>"])));
      case 'WhatIsAWallet':
        return html(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>"])));
      case 'WhatIsANetwork':
        return html(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["<w3m-what-is-a-network-view></w3m-what-is-a-network-view>"])));
      case 'GetWallet':
        return html(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["<w3m-get-wallet-view></w3m-get-wallet-view>"])));
      case 'Downloads':
        return html(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["<w3m-downloads-view></w3m-downloads-view>"])));
      case 'EmailVerifyOtp':
        return html(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["<w3m-email-verify-otp-view></w3m-email-verify-otp-view>"])));
      case 'EmailVerifyDevice':
        return html(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["<w3m-email-verify-device-view></w3m-email-verify-device-view>"])));
      case 'ApproveTransaction':
        return html(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["<w3m-approve-transaction-view></w3m-approve-transaction-view>"])));
      case 'Transactions':
        return html(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["<w3m-transactions-view></w3m-transactions-view>"])));
      case 'UpgradeEmailWallet':
        return html(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>"])));
      case 'UpdateEmailWallet':
        return html(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["<w3m-update-email-wallet-view></w3m-update-email-wallet-view>"])));
      case 'UpdateEmailWalletWaiting':
        return html(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["<w3m-update-email-wallet-waiting-view></w3m-update-email-wallet-waiting-view>"])));
      default:
        return html(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["<w3m-connect-view></w3m-connect-view>"])));
    }
  }
  async onViewChange(newView) {
    const {
      history
    } = RouterController.state;
    let xOut = -10;
    let xIn = 10;
    if (history.length < this.prevHistoryLength) {
      xOut = 10;
      xIn = -10;
    }
    this.prevHistoryLength = history.length;
    await this.animate([{
      opacity: 1,
      transform: 'translateX(0px)'
    }, {
      opacity: 0,
      transform: "translateX(".concat(xOut, "px)")
    }], {
      duration: 150,
      easing: 'ease',
      fill: 'forwards'
    }).finished;
    this.view = newView;
    await this.animate([{
      opacity: 0,
      transform: "translateX(".concat(xIn, "px)")
    }, {
      opacity: 1,
      transform: 'translateX(0px)'
    }], {
      duration: 150,
      easing: 'ease',
      fill: 'forwards',
      delay: 50
    }).finished;
  }
  getWrapper() {
    var _this$shadowRoot;
    return (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('div');
  }
};
W3mRouter.styles = styles;
__decorate([state()], W3mRouter.prototype, "view", void 0);
W3mRouter = __decorate([customElement('w3m-router')], W3mRouter);
export { W3mRouter };
//# sourceMappingURL=index.js.map